"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = void 0;
const _imports_1 = require("./_imports");
const _shared_1 = require("./_shared");
const MethodTypeSchema = _imports_1.z.literal('formula');
const AbstractConfigSchema = _imports_1.z.object({ type: MethodTypeSchema });
const AvailableFormulaFieldsSchema = _imports_1.z.object({
    commitmentAmount: _imports_1.z.optional(_imports_1.z.number()),
});
exports.ConfigSchema = AbstractConfigSchema.extend({
    type: _imports_1.z.literal('formula'),
    config: _shared_1.FormulaConfigSchema,
});
// TO BE IMPLEMENTED LATER
// | PointerConfig;
// export type PointerConfig = AbstractConfig & {
//   type: 'pointer';
//   method: string;
// };
// after PointerConfig is fetched from database, it gets converted into ResolvedPointerConfig
// by attaching the implementation to the method.
// export type ResolvedPointerConfig = PointerConfig & {
//   pointerImplementation: (
//     conn: Knex
//   ) => Promise<number>;
// };
//# sourceMappingURL=MaximumPrefundingAmount.js.map